import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=5d2a09ce&scoped=true"
import script from "./ContentList.vue?vue&type=script&lang=js"
export * from "./ContentList.vue?vue&type=script&lang=js"
import style0 from "./ContentList.vue?vue&type=style&index=0&id=5d2a09ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2a09ce",
  null
  
)

export default component.exports